// extracted by mini-css-extract-plugin
export default {"container":"AddOrRemove_container__nRJsC","button":"AddOrRemove_button__sZItV","quantity":"AddOrRemove_quantity__UIj1H"};